// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3AHKw","overflowing":"ReadFullNote_overflowing__2lZYF"};